function ScopeComponent(Component) {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"bdbecb4"}`, "");
  });
}
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-B4ZR5mwH.mjs.map
